import Vue from "vue"
import i18n from "@/modules/i18n"
import Header from "@/features/header/components/header-content"
import store from "@/store/"
import { BlinkistRoutes } from "@blinkist/frontend-helpers"

const initHeader = () => {
  const el = document.getElementById("header-content")

  if (!el) {
    return
  }

  const blinkistRoutes = new BlinkistRoutes(i18n.locale)

  Vue.prototype.$blinkistRoutes = blinkistRoutes

  const config = JSON.parse(el.dataset.config || "{}")

  new Vue({
    name: "HeaderContent",
    el,
    store,
    components: { Header },
    i18n,
    render(createElement) {
      return createElement(Header, {
        props: {
          hasLoginLink: config.hasLoginLink,
          hasSignupLink: config.hasSignupLink,
          hasPricingLink: config.hasPricingLink,
          hasUserMenu: config.hasUserMenu,
          hasLibraryLink: config.hasLibraryLink,
          hasHighlightsLink: config.hasHighlightsLink,
          hasDiscoverMenu: config.hasDiscoverMenu,
          hasSearch: config.hasSearch,
          hasUpgradeLink: config.hasUpgradeLink,
          hasBusinessLink: config.hasBusinessLink,
          hasCoachingLink: config.hasCoachingLink,
          showNewNavigation: config.showNewNavigation,
          cta: config.cta,
          failedToJoinOrganisation: config.failedToJoinOrganisation
        }
      })
    }
  })
}

export default initHeader
